export const SubscriptionStatus = {
    AwaitingActivation: "awaiting_activation",
    AwaitingPlanSelection: "awaiting_plan_selection",
    AwaitingQuotation: "awaiting_quotation",
    Active: "active",
    Expired: "expired",
    Unsubscribed: "unsubscribed",
    UnsubscribePending: "unsubscribe-pending",
    Suspended: "suspended",
    AwaitingQuotationApproval: "awaiting-quotation-approval"
} as const

export const BillingTermEnum = {
    OneYear: "OneYear",
    Monthly: "Monthly",
    ThreeYear: "ThreeYear"
} as const

export const SubscriptionTabEnum = {
    ENVIRONMENTS: "environments",
    TRUSTED_TENANTS: "trusted-tenants",
} as const;